module.exports = __webpack_public_path__ + "img/03.85295b5b.jpg";